module.exports = __webpack_public_path__ + "stylesheets/video-player_9029bb94ab8fb4f3e55f93f400015e9a.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/video-player.less
// module id = pbA1
// module chunks = 55